import * as actionTypes from '../actions/actionTypes';

export default function entityReducer(state = {}, action) {
  switch(action.type){
    case actionTypes.CREATE_ENTITY: {
      const entityId = action.newEntity.entityId;
      return Object.assign({}, {[entityId]: action.newEntity}, state);
    }
    case actionTypes.UPDATE_ENTITY: {
      const entityId = action.entityId;
      const entities = Object.assign({}, state);
      entities[entityId] = {...entities[entityId], ...action.entityData}
      return entities;
    }
    
    case actionTypes.UPDATE_ENTITY_NAME: {
      const entityId = action.entityId;
      const entityName = action.entityName;
      const entities = Object.assign({}, state);
      entities[entityId].entityName = entityName;
      return entities;
    }

    case actionTypes.UPDATE_ENTITY_STATUS: {
      const {entityId, caseStatus} = action;
      let entities =  Object.assign({}, state);
      entities[entityId].status = caseStatus;
      return entities;
    }
    case actionTypes.SET_ENTITY_TO_NO_CONFLICT_STATE: {
      const {entityId} = action;
      let entities =  Object.assign({}, state);
      entities[entityId].status = 'no_conflicts';
      return entities;
    }
    case actionTypes.UPDATE_ENTITY_WITH_CASEID: {
      const {entityId, caseId} = action;
      let entities = Object.assign({}, state);
      entities[entityId].caseId = caseId;
      return entities;
    }
    case actionTypes.DELETE_ENTITY: {
      var entities = Object.assign({}, state);
      delete entities[action.entityId];
      return entities;
    }
    case actionTypes.SET_ENTITIES: {
      return action.entities.reduce((accumulator, entity, index) => {
        entity.entityId = entity.id;
        entity.caseId = action.cases[index].id;
        accumulator[entity.id] = entity;
        return accumulator;
      }, {});
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/createAcase/reducers/entityReducer.js